module.exports = __webpack_public_path__ + "img/y3.657832ec.png";